// extracted by mini-css-extract-plugin
export default {"Policies":"policies_Policies__K+Xpd","paginationContainer":"policies_paginationContainer__FX4qC","paginationArrow":"policies_paginationArrow__jY0rL"};